const clearAsyncValidationPromises = (state, key) => (result) => {
  delete state.asyncValidationPromises[key];
  return result;
};

export default clearAsyncValidationPromises;
